export const exportTypesEnum = {
  FTP: 'FTP',
  SFTP: 'SFTP',
  EMAIL: 'EMAIL',
  HTTP: 'HTTP',
} as const

export type ExportTypesEnum = (typeof exportTypesEnum)[keyof typeof exportTypesEnum]

export type ExportTypes = ExportTypesEnum